import { IEquipment } from '@/pages/Equipment/equipment.types'
import useEquipment from '@/pages/Equipment/hooks/useEquipment'
import useSameAddressEquipment from '@/pages/Equipment/hooks/useSameAddressEquipment'
import DropdownFadeInPanel from '@/shared/Dropdowns/DropdownFadeInPanel'
import usePopup from '@/shared/hooks/usePopup'
import ArrowDown from '@/assets/icons/arrowDown.svg?react'
import { IOption } from '@/types/global'
import { useMemo, useRef } from 'react'
import css from './sameAddressEquipmentDropdownInput.module.css'
import { IDropdownOption } from '@/shared/Inputs/DropdownInput/dropdown.types'
import DropdownInputListItem from '@/shared/Dropdowns/DropdownInputListItem'

interface IProps {
  liftId: number
  name?: string
  onSelect: (id: number, name: string) => void
}

const SameAddressEquipmentDropdownInput = (props: IProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const { open, setOpen } = usePopup(ref)
  const equipment = useEquipment(props.liftId)
  const sameAddressEquipment = useSameAddressEquipment(equipment)

  const addressNavigationState = useMemo(() => {
    const sorted = [...sameAddressEquipment, equipment].sort((left, right) =>
      (left.location?.locationDescription || '').localeCompare(right.location?.locationDescription || '', 'ru')
    )
    const currentIndex = sorted.findIndex((e) => e.id === equipment.id)

    return { currentIndex, equipments: sorted, equipment: sorted[currentIndex] }
  }, [equipment, sameAddressEquipment])

  const selectEquipmentOptions: IOption<IEquipment['id']>[] = useMemo(() => {
    return addressNavigationState.equipments.map((e) => ({
      value: e.id,
      title: e.location?.locationDescription || '-',
    }))
  }, [addressNavigationState.equipments])

  const renderOption = (option: IDropdownOption) => {
    return (
      <DropdownInputListItem
        key={option.value as any}
        onClick={handleChange(option.value)}
        active={option.value === addressNavigationState.equipment.id}
      >
        <p className="text-nm">{option.title}</p>
      </DropdownInputListItem>
    )
  }

  const handleChange = (optionValue: number) => () => {
    props.onSelect(optionValue, props.name)
    setOpen(false)
  }

  if (!addressNavigationState.equipment.location) return null

  return (
    <div
      ref={ref}
      className={css.wrapper}
      data-open={open}
      data-disabled={!Boolean(sameAddressEquipment.length)}
      onClick={() => Boolean(sameAddressEquipment.length) && setOpen(!open)}
    >
      <div
        data-open={open}
        className="text-heading-3 line-clamp"
        title={addressNavigationState.equipment.location.locationDescription}
      >
        {addressNavigationState.equipment.location.locationDescription || 'Лифт'}
      </div>

      {Boolean(sameAddressEquipment.length) && (
        <ArrowDown data-open={open} data-selected={Boolean(true)} className={css.arrow} />
      )}
      <DropdownFadeInPanel position="right" style={{ width: '360px' }} open={open}>
        {selectEquipmentOptions.map(renderOption)}
      </DropdownFadeInPanel>
    </div>
  )
}

export default SameAddressEquipmentDropdownInput
